module.exports = __webpack_public_path__ + "assets/img/47874ec7b333fa8c72203903e97d4f82.svg";